import { render, staticRenderFns } from "./advertCenter.vue?vue&type=template&id=0c473f22&scoped=true"
import script from "./advertCenter.vue?vue&type=script&lang=js"
export * from "./advertCenter.vue?vue&type=script&lang=js"
import style0 from "./advertCenter.vue?vue&type=style&index=0&id=0c473f22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c473f22",
  null
  
)

export default component.exports